<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import Modal from "$app/components/Modal.svelte"
  import RecognitionDialog from "$app/Pages/Plans/Recognitions/RecognitionDialog.svelte"
  import { Stretch } from "svelte-loading-spinners"
  import { xhr, badgeImage, constBadgeTitles, formatDate } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  import clappingPNG from "@images/recognitions/clapping.png"
  import firePNG from "@images/accomplishments/fire.png"
  import badgePNG from "@images/accomplishments/badge.png"
  import targetPNG from "@images/accomplishments/target.png"
  import recognitionStreak from "@images/accomplishments/recognition-streak.png"
  import progressStreak from "@images/accomplishments/progress-streak.png"

  let props = $props()
  let plan: PlanType = props.plan
  let departments = props.departments
  let brand_purpose = props.brand_purpose
  let blue_sky_vision = props.blue_sky_vision
  let core_values = props.core_values
  let current_user: UserType = props.current_user
  let onboarding: any = props.onboarding

  appStore.plan = plan
  appStore.departments = departments
  appStore.current_user = current_user

  let openRecognitionModal = $state(false)

  let accomplishmentsPromise = $state(Promise.resolve())
  accomplishmentsPromise = fetchData()

  let users = []
  let month_date_start, month_date_end
  let week_date_start, week_date_end
  let week_date_range
  let stats_all_time = $state({})
  let stats_month = $state({})
  let stats_week = $state({})
  let weekly_streaks = $state({})
  let badges = []

  let recognition_filter = $state("week")
  let progress_filter = $state("week")

  async function fetchData() {
    try {
      const resp = await xhr.get(
        `/api/v1/plans/${plan.id}/accomplishments.json`
      )
      users = resp.data.users
      month_date_start = resp.data.month_date_start
      month_date_end = resp.data.month_date_end
      week_date_start = resp.data.week_date_start
      week_date_end = resp.data.week_date_end
      //dateStart = new Date(`${date_start}T00:00:00`)
      //dateEnd = new Date(`${date_end}T23:59:59`)

      week_date_range = resp.data.week_date_range
      stats_all_time = resp.data.stats_all_time
      stats_month = resp.data.stats_month
      stats_week = resp.data.stats_week
      weekly_streaks = resp.data.weekly_streaks
      badges = sortBadges(resp.data.badges)
    } catch (e) {
      console.log(e)
      alert("There was an error fetching the data. Please try again.")
    }
  }

  function sortBadges(badges) {
    return badges.reduce(function (map, obj) {
      if (map[obj.name]) {
        map[obj.name].levels.push(obj.level)
        if (obj.level > map[obj.name].max_level) {
          map[obj.name].max_level = obj.level
        }
      } else {
        map[obj.name] = {
          levels: [obj.level],
          max_level: obj.level,
          name: obj.name,
          description: obj.description,
          created_at: obj.created_at
        }
      }

      var resultHash = {}
      var keys = Object.keys(map)
      keys
        .sort(function (a, b) {
          return map[a].created_at - map[b].created_at
        })
        .forEach(function (k) {
          resultHash[k] = map[k]
        })
      return resultHash

      //return map
    }, {})
  }
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 pb-8">
    <div>
      <h1 class="text-xl md:text-2xl lg:text-3xl">Accomplishments</h1>
    </div>

    {#await accomplishmentsPromise}
      <div class="grid mt-12" style="place-items:center">
        <Stretch size="80" color="gray" />
      </div>
    {:then}
      <div class="mt-12">
        <div class="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-x-4">
          <div class="bg-amber-200 rounded-lg shadow py-4 px-6">
            <div class="flex justify-between items-center">
              <h2 class="text-lg font-bold flex items-center">
                <img
                  src={clappingPNG}
                  class="size-10 mr-3"
                  alt="Recognitions"
                />
                RECOGNITIONS
              </h2>
              <span class="isolate inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  onclick={() => (recognition_filter = "week")}
                  class:active-btn={recognition_filter === "week"}
                  class="relative -ml-px inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                  >This Week</button
                >
                <button
                  type="button"
                  onclick={() => (recognition_filter = "month")}
                  class:active-btn={recognition_filter === "month"}
                  class="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                  >Past Month</button
                >

                <button
                  type="button"
                  onclick={() => (recognition_filter = "all")}
                  class:active-btn={recognition_filter === "all"}
                  class="relative inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                  >All Time</button
                >
              </span>
            </div>
            <div class="grid grid-cols-2 items-center pt-6 pb-3">
              {#if recognition_filter === "all"}
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl md:text-5xl font-semibold text-amber-800">
                    {stats_all_time.recognitions_sent || 0}
                  </p>
                  <p class="text-xs">TOTAL SENT</p>
                </div>
                <div class="flex flex-col items-center justify-center">
                  <p class="text-3xl md:text-5xl font-semibold text-amber-800">
                    {stats_all_time.recognitions_received || 0}
                  </p>
                  <p class="text-xs">TOTAL RECEIVED</p>
                </div>
              {:else if recognition_filter === "month"}
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl md:text-5xl font-semibold text-amber-800">
                    {stats_month.recognitions_sent}
                  </p>
                  <p class="text-xs">SENT PAST MONTH</p>
                </div>
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl md:text-5xl font-semibold text-amber-800">
                    {stats_month.recognitions_received || 0}
                  </p>
                  <p class="text-xs">RECEIVED PAST MONTH</p>
                </div>
              {:else if recognition_filter === "week"}
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl md:text-5xl font-semibold text-amber-800">
                    {stats_week.recognitions_sent || 0}
                  </p>
                  <p class="text-xs">SENT THIS WEEK</p>
                </div>
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl md:text-5xl font-semibold text-amber-800">
                    {stats_week.recognitions_received || 0}
                  </p>
                  <p class="text-xs">RECEIVED THIS WEEK</p>
                </div>
              {/if}
            </div>
          </div>
          <div class="bg-green-200 rounded-lg shadow py-4 px-6">
            <div class="flex justify-between items-center">
              <h2 class="text-lg font-bold flex items-center">
                <img
                  src={targetPNG}
                  class="size-10 mr-3"
                  alt="Progress Reports"
                />
                PROGRESS REPORTS
              </h2>
              <span class="isolate inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  onclick={() => (progress_filter = "week")}
                  class:active-btn={progress_filter === "week"}
                  class="relative -ml-px inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                  >This Week</button
                >
                <button
                  type="button"
                  onclick={() => (progress_filter = "month")}
                  class:active-btn={progress_filter === "month"}
                  class="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                  >Past Month</button
                >
                <button
                  type="button"
                  onclick={() => (progress_filter = "all")}
                  class:active-btn={progress_filter === "all"}
                  class="relative inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                  >All Time</button
                >
              </span>
            </div>
            <div class="grid grid-cols-2 items-center pt-6 pb-3">
              {#if progress_filter === "all"}
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl lg:text-5xl font-semibold text-green-800">
                    {stats_all_time.goal_progresses || 0}
                  </p>
                  <p class="text-xs">TOTAL GOAL PROGRESSES</p>
                </div>
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl lg:text-5xl font-semibold text-green-800">
                    {stats_all_time.task_progresses || 0}
                  </p>
                  <p class="text-xs">TOTAL TASK PROGRESSES</p>
                </div>
              {:else if progress_filter === "month"}
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl lg:text-5xl font-semibold text-green-800">
                    {stats_month.goal_progresses || 0}
                  </p>
                  <p class="text-xs">GOAL PROGRESSES PAST MONTH</p>
                </div>
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl lg:text-5xl font-semibold text-green-800">
                    {stats_month.task_progresses || 0}
                  </p>
                  <p class="text-xs">TASK PROGRESSES PAST MONTH</p>
                </div>
              {:else if progress_filter === "week"}
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl lg:text-5xl font-semibold text-green-800">
                    {stats_week.goal_progresses || 0}
                  </p>
                  <p class="text-xs">GOAL PROGRESSES THIS WEEK</p>
                </div>
                <div class="flex flex-col items-center justify-center gap-2">
                  <p class="text-3xl lg:text-5xl font-semibold text-green-800">
                    {stats_week.task_progresses || 0}
                  </p>
                  <p class="text-xs">TASK PROGRESSES THIS WEEK</p>
                </div>
              {/if}
            </div>
          </div>
        </div>
        <div class="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-x-4">
          <div class="bg-orange-200 rounded-lg shadow py-4 px-6">
            <div class="flex justify-between items-center">
              <h2 class="text-lg font-bold flex items-center">
                <img src={firePNG} class="size-10 mr-3" alt="Streaks" />
                STREAKS
              </h2>
            </div>
            <div class="grid grid-cols-2 items-stretch mt-6 gap-x-8">
              {#if weekly_streaks.recognition && weekly_streaks.recognition["active?"]}
                <div
                  class="flex flex-col justify-stretch items-center bg-amber-50 rounded-md"
                >
                  <p
                    class="text-amber-900 text-sm font-bold text-center bg-amber-100 py-2 px-2 rounded-md w-full border-b border-amber-200"
                  >
                    Recognitions Streak
                  </p>
                  <img
                    src={recognitionStreak}
                    class="size-32 mx-auto"
                    alt="Recognitions Streak"
                  />
                  <p
                    class="text-2xl lg:text-3xl font-semibold text-orange-800 px-2 text-center mt-2"
                  >
                    {weekly_streaks.recognition.streak_count}
                    {weekly_streaks.recognition.streak_count > 1
                      ? "WEEKS"
                      : "WEEK"}
                  </p>

                  {#if stats_week.recognitions_sent == 0}
                    <div class="px-2 py-3">
                      <button
                        class="flex flex-nowrap items-center px-2 py-2 bg-amber-100 border border-amber-200 hover:shadow-lg text-sm font-medium rounded text-black focus:outline-none hover:bg-amber-50"
                        type="button"
                        data-name="send-recognition"
                        onclick={() => (openRecognitionModal = true)}
                      >
                        You have not sent a recognition this week. Send one
                        today to keep your streak going!
                      </button>
                    </div>
                  {/if}

                  <p class="text-xs text-center px-2 italic mt-2">
                    You started your streak on
                    <br />
                    <span class="font-bold"
                      >{formatDate(
                        weekly_streaks.recognition.streak_started
                      )}</span
                    >
                  </p>
                  {#if weekly_streaks.recognition.max_streak_count > 0}
                    <p class="text-sm text-center px-2 italic mt-2 mb-4">
                      Your longest streak was
                      <br />
                      <span class="font-bold">
                        {weekly_streaks.recognition.max_streak_count}
                        {weekly_streaks.recognition.max_streak_count > 1
                          ? "WEEKS"
                          : "WEEK"}
                      </span>
                    </p>
                  {/if}
                </div>
              {:else}
                <div
                  class="flex flex-col justify-stretch items-center bg-amber-50 rounded-md"
                >
                  <p
                    class="text-amber-900 text-sm font-bold text-center bg-amber-100 py-2 px-2 rounded-md w-full border-b border-amber-200"
                  >
                    Recognitions Streak
                  </p>
                  <p
                    class="text-xl lg:text-2xl font-semibold text-amber-800 px-2 text-center mt-4"
                  >
                    NOT STARTED
                  </p>
                  <p class="text-sm text-center px-4 italic mt-2">
                    Start your recognition streak by sending one today!
                  </p>

                  <div class="my-4">
                    <button
                      class="flex flex-nowrap items-center px-4 py-2 bg-amber-100 border border-amber-200 hover:shadow-lg text-sm font-medium rounded text-black focus:outline-none hover:bg-amber-50"
                      type="button"
                      data-name="send-recognition"
                      onclick={() => (openRecognitionModal = true)}
                    >
                      <div
                        class="whitespace-nowrap font-bold text-xs md:text-sm"
                      >
                        Send Recognition
                      </div>
                    </button>
                  </div>

                  {#if weekly_streaks.recognition?.max_streak_count > 0}
                    <p class="text-sm text-center px-4 italic mt-2 mb-4">
                      Your longest streak was
                      <br />
                      <span class="font-bold">
                        {weekly_streaks.recognition.max_streak_count}
                        {weekly_streaks.recognition.max_streak_count > 1
                          ? "WEEKS"
                          : "WEEK"}
                      </span>
                    </p>
                  {/if}
                </div>
              {/if}

              {#if weekly_streaks.progress && weekly_streaks.progress["active?"]}
                <div
                  class="flex flex-col justify-stretch items-center bg-green-50 rounded-md"
                >
                  <p
                    class="text-green-900 text-sm font-bold text-center bg-green-100 py-2 px-2 rounded-md w-full border-b border-green-200"
                  >
                    Progresses Streak
                  </p>
                  <img
                    src={progressStreak}
                    class="size-32 mx-auto"
                    alt="Progresses Streak"
                  />
                  <p
                    class="text-2xl lg:text-3xl font-semibold text-orange-800 px-2 text-center mt-1"
                  >
                    {weekly_streaks.progress.streak_count}
                    {weekly_streaks.progress.streak_count > 1
                      ? "WEEKS"
                      : "WEEK"}
                  </p>

                  {#if stats_week.goal_progresses == 0 && stats_week.task_progresses == 0}
                    <div class="px-2 py-3">
                      <a
                        class="flex flex-nowrap items-center px-4 py-2 bg-green-100 border border-green-200 hover:shadow-lg text-sm font-medium rounded text-black focus:outline-none hover:bg-green-50"
                        type="button"
                        href={`/plans/${plan.id}/activities`}
                      >
                        You have not entered progress this week. Do it today to
                        keep your streak going!
                      </a>
                    </div>
                  {/if}
                  <p class="text-xs text-center px-2 italic mt-2">
                    You started your streak on
                    <br />
                    <span class="font-bold"
                      >{formatDate(
                        weekly_streaks.progress.streak_started
                      )}</span
                    >
                  </p>
                  {#if weekly_streaks.progress.max_streak_count > 0}
                    <p class="text-sm text-center px-2 italic mt-2 mb-4">
                      Your longest streak was
                      <br />
                      <span class="font-bold">
                        {weekly_streaks.progress.max_streak_count}
                        {weekly_streaks.progress.max_streak_count > 1
                          ? "WEEKS"
                          : "WEEK"}
                      </span>
                    </p>
                  {/if}
                </div>
              {:else}
                <div
                  class="flex flex-col justify-stretch items-center bg-green-50 rounded-md"
                >
                  <p
                    class="text-green-900 text-sm font-bold text-center bg-green-100 py-2 px-2 rounded-md w-full border-b border-green-200"
                  >
                    Progresses Streak
                  </p>
                  <p
                    class="text-xl lg:text-2xl font-semibold text-green-800 px-2 text-center mt-4"
                  >
                    NOT STARTED
                  </p>

                  <p class="text-sm text-center px-4 italic mt-2">
                    Start your progress streak by adding progress today to a
                    goal or task on the Activity page.
                  </p>
                  <div class="my-4">
                    <a
                      class="flex flex-nowrap items-center px-4 py-2 bg-green-100 border border-green-200 hover:shadow-lg text-sm font-medium rounded text-black focus:outline-none hover:bg-green-50"
                      type="button"
                      data-name="send-recognition"
                      href={`/plans/${plan.id}/activities`}
                    >
                      <div
                        class="whitespace-nowrap font-bold text-xs md:text-sm"
                      >
                        Visit Activity Page
                      </div>
                    </a>
                  </div>

                  {#if weekly_streaks.progress?.max_streak_count > 0}
                    <p class="text-sm text-center px-4 italic mt-2 mb-4">
                      Your longest streak was
                      <br />
                      <span class="font-bold">
                        {weekly_streaks.progress.max_streak_count}
                        {weekly_streaks.progress.max_streak_count > 1
                          ? "WEEKS"
                          : "WEEK"}
                      </span>
                    </p>
                  {/if}
                </div>
              {/if}
            </div>
          </div>

          <div
            class="bg-blue-200 rounded-lg shadow py-4 px-6 max-h-156 overflow-y-auto"
          >
            <div class="flex justify-start items-center">
              <img src={badgePNG} class="size-10 mr-3" alt="Badges" />
              <h2 class="text-lg font-bold">BADGES</h2>
            </div>
            <div class="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-1">
              {#each Object.entries(badges).reverse() as [id, badge]}
                <div
                  class="flex items-start justify-center bg-blue-400 py-3 px-2"
                >
                  <div
                    class="flex flex-col items-center justify-center relative"
                  >
                    <div
                      class="mb-1 inline-flex items-center text-sm font-bold text-white whitespace-nowrap"
                    >
                      {constBadgeTitles[badge.name]}
                    </div>
                    <div class="size-32 relative">
                      <img
                        src={badgeImage(badge.name, badge.max_level)}
                        class="size-32"
                        alt={badge.name}
                      />
                    </div>
                    {#if badge.levels.length > 1}
                      <div
                        class="mt-4 mb-2 inline-flex items-center text-xs font-medium text-gray-100 border-b border-gray-200/50 whitespace-nowrap"
                      >
                        Previously earned badges
                      </div>
                      <div
                        class="flex -space-x-10 overflow-hidden overflow-x-auto"
                      >
                        {#each badge.levels.splice(0, badge.levels.length - 1) as level}
                          <img
                            src={badgeImage(badge.name, level)}
                            class="inline-block size-16"
                            alt={badge.name}
                          />
                        {/each}
                      </div>
                    {/if}
                  </div>
                </div>
              {:else}
                <div
                  class="flex items-center justify-center w-full col-span-2 lg:col-span-3"
                >
                  <p
                    class="py-1 px-3 bg-blue-50 font-bold rounded-md text-center"
                  >
                    You currently do not have any badges.
                  </p>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    {/await}
  </div>
</Layout>

<Modal
  closeButton={true}
  closeOnEsc={true}
  closeOnOuterClick={true}
  large={true}
  bind:open={openRecognitionModal}
>
  <RecognitionDialog
    plan_id={plan.id}
    on:created={() => {
      openRecognitionModal = false
      fetchData()
    }}
  />
</Modal>

<style>
  .active-btn {
    background-color: #4b5563;
    color: #f3f4f6;
    font-weight: bold;
  }
</style>
